import React from "react";
import "../Styles/dashboardfrontpage.css";
import { PieChart, Pie, Cell } from "recharts";
import {
  Users,
  UserCircle2,
  LogOut,
  ImagePlus,
  UserPlus,
  UsersRound,
  Contact,
  ArrowRight,
} from "lucide-react";

const stats = [
   {
    label: "Total Community Members",
    value: "2,500",
    icon: "/assets/Management.png",   // now a PNG path, not a component
    isImage: true,
    bg: "#FDECE3",
    fg: "#F0703C",
  },
  {
    label: "Total Collaborators",
    value: "1,600",
    icon:  "/assets/coll.png", 
    isImage: true,
    bg: "#F1E9FE",
    fg: "#8B5CF6",
  },
  {
    label: "HR Festival Registrations",
    value: "3,256",
    icon:  "/assets/reg.png", 
    isImage: true,
   
    bg: "#E4F8ED",
    fg: "#22B573",
  },
  {
    label: "Total Subscribers",
    value: "3,256",
    icon: "/assets/su.png", 
    isImage: true,
    bg: "#E5EEFF",
    fg: "#3B6FEA",
  },
];

const quickActions = [
  {
    title: "Upload Event Photos",
    subtitle: "Add a new photos to the gallery",
    icon: ImagePlus,
    bg: "#FDECE3",
    fg: "#F0703C",
    arrowBg: "#F0703C",
  },
  {
    title: "Event Registrations",
    subtitle: "See all sign-ups",
    icon: UserPlus,
    bg: "#F1E9FE",
    fg: "#8B5CF6",
    arrowBg: "#8B5CF6",
  },
  {
    title: "Community Members",
    subtitle: "Manage your HR community",
    icon: UsersRound,
    bg: "#E4F8ED",
    fg: "#22B573",
    arrowBg: "#22B573",
  },
  {
    title: "View Subscribers",
    subtitle: "Manage your Subscribers",
    icon: Contact,
    bg: "#E5EEFF",
    fg: "#3B6FEA",
    arrowBg: "#3B6FEA",
  },
];

const registrations = [
  {
    name: "Sanjay M",
    company: "Inypeople Technologies",
    designation: "UI/UX Designer",
    contact: "1234543219",
    status: "Paid",
  },
  {
    name: "Sanjay M",
    company: "Inypeople Technologies",
    designation: "UI/UX Designer",
    contact: "1234543219",
    status: "Unpaid",
  },
  {
    name: "Sanjay M",
    company: "Inypeople Technologies",
    designation: "UI/UX Designer",
    contact: "1234543219",
    status: "Paid",
  },
  {
    name: "Sanjay M",
    company: "Inypeople Technologies",
    designation: "UI/UX Designer",
    contact: "1234543219",
    status: "Unpaid",
  },
];

const pieData = [
  { name: "Paid", value: 788, color: "#22C55E" },
  { name: "Pending", value: 212, color: "#F97316" },
];

export default function AdminDashboard() {
  return (
    <div className="vhrd">
      <div className="topbar">
        <h1>Dashboard</h1>
        <button className="logout-btn">
          <LogOut />
          Logout
        </button>
      </div>

        <div className="welcome">
          <h2>Welcome to the Admin Dashboard!</h2>
          <p>
            Welcome back to Vanakkam HRD Administration. Manage community
            members, event registrations and gallery from one place.
          </p>
        </div>

        <div className="stat-grid">
  {stats.map((s) => (
    <div className="front-stat-card" key={s.label}>
      <div className="stat-icon" style={{ background: s.bg }}>
        {s.isImage ? (
          <img src={s.icon} alt={s.label} className="stat-icon-img" />
        ) : (
          <s.icon style={{ color: s.fg }} />
        )}
      </div>
      <div>
        <div className="stat-value">{s.value}</div>
        <div className="stat-label">{s.label}</div>
      </div>
    </div>
  ))}
</div>

        <div className="panel quick-panel">
          <div className="section-title">Quick Actions</div>
          <div className="quick-grid">
            {quickActions.map((q) => (
              <div className="quick-card" key={q.title}>
                <div className="quick-icon" style={{ background: q.bg }}>
                  <q.icon style={{ color: q.fg }} />
                </div>
                <div className="quick-row">
                  <div>
                    <p className="quick-title">{q.title}</p>
                    <p className="quick-subtitle">{q.subtitle}</p>
                  </div>
                  <div
                    className="quick-arrow"
                    style={{ background: q.arrowBg }}
                  >
                    <ArrowRight />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bottom-row">
          <div className="panel">
            <h3>Event Summary</h3>
            <div className="donut-wrap">
              <PieChart width={180} height={180}>
                <Pie
                  data={pieData}
                  dataKey="value"
                  innerRadius={58}
                  outerRadius={82}
                  startAngle={90}
                  endAngle={-270}
                  stroke="none"
                >
                  {pieData.map((entry) => (
                    <Cell key={entry.name} fill={entry.color} />
                  ))}
                </Pie>
              </PieChart>
              <div
                className="donut-center"
                style={{ marginTop: -130, marginBottom: 60 }}
              >
                <div style={{ fontSize: 11, color: "var(--muted)" }}>
                  Total
                </div>
                <div style={{ fontSize: 20, fontWeight: 700 }}>1000</div>
              </div>
              <div className="donut-legend">
                <div className="legend-item">
                  <span
                    className="legend-dot"
                    style={{ background: "#22C55E" }}
                  />
                  Paid&nbsp;788
                </div>
                <div className="legend-item">
                  <span
                    className="legend-dot"
                    style={{ background: "#F97316" }}
                  />
                  Pending&nbsp;212
                </div>
              </div>
            </div>
          </div>

          <div className="panel">
            <h3>Recent Registrations</h3>
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Company</th>
                  <th>Designation</th>
                  <th>Contact</th>
                  <th>Payment Status</th>
                </tr>
              </thead>
              <tbody>
                {registrations.map((r, i) => (
                  <tr key={i}>
                    <td>
                      <div className="person-cell">
                        <div className="avatar" />
                        {r.name}
                      </div>
                    </td>
                    <td>{r.company}</td>
                    <td>{r.designation}</td>
                    <td>{r.contact}</td>
                    <td>
                      <span
                        className={`status-pill ${r.status.toLowerCase()}`}
                      >
                        {r.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <a className="view-all">
              View All Registrations <ArrowRight />
            </a>
          </div>
        </div>
    </div>
  );
}